const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/home',
  STORES: '/stores',
  CATEGORIES: '/storesRestaurantsCategories/storesRestaurantsCategories',
  EVENTS: '/events',
  // GASTRONOMIC_TUESDAY: '/events/gastronomic-tuesday',
  FAQ: '/faq',
  TERMS_AND_POLICIES: '/termsAndPolicies',
  PARKING: '/parking',
  NOTIFICATION: '/notification',
  SHOPPING_INFO: '/shoppingInfo',
  SERVICES: '/service',
  USER_PROFILE: '/user-profile',
  REGISTER_USER: '/registerUser',
  HOME: '/home/home',
  INCONCERT: '/in-concert/in-concert',
  PROMOTIONS: '/promotions',
  SELLER_CODE: '/seller-code',
  BENEFITS_CONFIG: '/benefits-config',
};

export const paths = {
  root: '/',
  auth: {
    root: ROOTS.AUTH,
    login: `${ROOTS.AUTH}/login`,
    changePassword: `${ROOTS.AUTH}/change-password`,
  },

  // PAGES
  inConcert: {
    root: ROOTS.INCONCERT,
  },

  promotions: {
    root: ROOTS.PROMOTIONS,
  },

  home: {
    root: ROOTS.HOME,
  },

  registerUser: {
    root: ROOTS.REGISTER_USER,
  },

  notification: {
    root: ROOTS.NOTIFICATION,
  },

  shoppingInfo: {
    root: ROOTS.SHOPPING_INFO,
  },

  service: {
    root: ROOTS.SERVICES,
  },

  termsAndPolicies: {
    root: ROOTS.TERMS_AND_POLICIES,
  },

  parking: {
    root: ROOTS.PARKING,
  },

  // gastronomicTuesday: {
  //   root: ROOTS.GASTRONOMIC_TUESDAY,
  // },

  storesRestaurantsCategories: {
    root: ROOTS.CATEGORIES,
  },

  dashboard: {
    root: ROOTS.DASHBOARD,
  },

  events: {
    root: ROOTS.EVENTS,
  },

  faq: {
    root: ROOTS.FAQ,
  },

  stores: {
    root: ROOTS.STORES,
  },

  userProfile: {
    root: ROOTS.USER_PROFILE,
  },

  sellerCode: {
    root: ROOTS.SELLER_CODE,
  },

  benefitsConfig: {
    root: ROOTS.BENEFITS_CONFIG,
  },

  error: {
    notFound: '/404',
    forbidden: '/403',
    serverError: '/500',
  },
};
